import script from "./Cell.vue?vue&type=script&setup=true&lang=js"
export * from "./Cell.vue?vue&type=script&setup=true&lang=js"

import "./Cell.vue?vue&type=style&index=0&id=380112e0&lang=scss"

export default script